import templateSearch from '../../../../../Template/config/components/selection/Search'
import searchFilter from './SearchFilter'
import tagHierarchy from './TagHierarchy'

export default {
    ...templateSearch,
    searchFilter,
    tagHierarchy
}
